import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Panel from '../../UniformComponents/Panel'
import DataTable from './DataTable'
import ProductSelector from './ProductSelector'
import Spinner from '../../UniformComponents/Spinner'
import ComparisonModal from './ComparisonModal'
import BenchmarkingModal from './BenchmarkingModal'
import Button from '../../UniformComponents/Button'
import Switch from '../../UniformComponents/Switch'

@observer
class DataPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    renderGuide = () => (
        <div className="guideBody">
            <div className="steps">
                <h3>Step 1</h3>
                <p>
                    Select your event and industry preferences
                </p>
            </div>
            <div className="steps">
                <h3>Step 2</h3>
                <p>
                    Select our required questions from the question lists below
                </p>
            </div>
            <div className="steps">
                <h3>Step 3</h3>
                <p>
                    Drag and drop the questions you require to your question list
                </p>
            </div>
        </div>
    )

    spinner = () => (
        <div className="spinner">
            <img src={`${process.env.CDN_URL}/includes/images/loading.svg`} alt="loader" />
        </div>
    )

    render() {
        const { DataExplorerStore } = this.props
        const {
            questions,
            reportData,
            showProductSelector,
            filterReportData,
            loadingData,
            toggleComparisonSelector,
            toggleBenchmarkingModal,
            toggleProductSelector,
            hasBranches,
        } = DataExplorerStore
        const showDataControls = reportData && reportData.length

        return (
            <div className="dataPanel">
                <Panel cssClass="reportPanel">
                    {showDataControls ? (
                        <div className="buttons">
                            {hasBranches
                                ? (
                                    <Switch
                                        label={(
                                            <span style={{ fontWeight: '700', color: '#2B3C44' }}>
                                                {i18n.t('report_toggleNestedBranches_label')}
                                            </span>
                                        )}
                                        onToggle={DataExplorerStore.toggleShowBranches}
                                        state={DataExplorerStore.showBranches}
                                        isLeft
                                    />
                                )
                                : null }
                            {process.env.USE_BENCHMARKING_MODAL ? (
                                <Button
                                    onClick={toggleBenchmarkingModal}
                                    label={i18n.t('benchmarkModal.buttonTitle')}
                                    icon="fa-regular fa-retweet"
                                    cssClass="tertiary regular"
                                />
                            ) : (
                                <Button
                                    onClick={toggleComparisonSelector}
                                    label="Add comparison"
                                    icon="fa-regular fa-filter-list"
                                    cssClass="tertiary regular"
                                />
                            )}
                            <Button
                                onClick={toggleProductSelector}
                                label="Add filters"
                                icon="fa-regular fa-circle-plus"
                                cssClass="tertiary regular"
                                id="productSelector"
                            />
                        </div>
                    ) : null}
                    {showProductSelector
                        ? <ProductSelector DataExplorerStore={DataExplorerStore} />
                        : null}
                    {reportData && !loadingData ? (
                        <div className="tablesContainer">
                            {filterReportData().map((d) => (
                                <DataTable DataExplorerStore={DataExplorerStore} data={d} />
                            ))}
                        </div>
                    ) : null}

                    {(!questions || !questions.length) && (!reportData || !reportData.length)
                        ? (
                            <div className="noOptions">
                                <div>
                                    <img style={{ width: '450px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/noDashboards.svg`} />
                                    <div className="title">{i18n.t('dataExplorer.emptyMsg')}</div>
                                </div>
                            </div>
                        )
                        : null}
                    {(questions && questions.length && (!reportData || !reportData.length)) || loadingData
                        ? (
                            <div className="noQuestions">
                                <div>
                                    {loadingData ? <Spinner /> : (
                                        <Fragment>
                                            <img style={{ width: '450px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/noDashboards.svg`} />
                                            <div className="title">Drag and drop</div>
                                            <div className="subtitle">
                                                Drag and drop your required questions
                                                {' '}
                                                <br />
                                                {' '}
                                                into the
                                                {' '}
                                                <span style={{ color: '#16CCC1', fontWeight: 'bold' }}>Rows</span>
                                                {' '}
                                                area
                                            </div>
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        )
                        : null }
                </Panel>
                <ComparisonModal DataExplorerStore={DataExplorerStore} />
                <BenchmarkingModal DataExplorerStore={DataExplorerStore} />
            </div>
        )
    }
}

export default DataPanel
